// extracted by mini-css-extract-plugin
export default {"errorMessage":"styles_errorMessage__EMUDp","card":"styles_card__sSgBE","profileInfo":"styles_profileInfo__3TTE6","placeholder":"styles_placeholder__pvchF"};